// SEC-N: the one place HTML escaping lives.
//
// Several list and print views build a small HTML string by hand (a route with
// arrow icons between stop names, an address with its newlines turned into
// `<br>`) and render it with `v-html`. Every value woven into those strings is
// org-entered free text: a location name, a customer address. A location saved
// as `<img src=x onerror=...>` would otherwise execute on whoever opens the
// Dispatch board, with the session's CSRF token sitting in sessionStorage.
//
// The rule these helpers encode: escape the untrusted text FIRST, then add the
// intentional markup. Escaping afterwards would neuter the markup you meant to
// keep; interleaving the two by hand is what produced six near-identical
// copies of this code.

// Turn a value into text that is inert inside an HTML context. `null` and
// `undefined` become the empty string rather than the words "null"/"undefined",
// which is what every call site wants for a missing address or name.
export function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Addresses are stored as a single free-text block; the line breaks the user
// typed are the only formatting worth preserving, so they become the only
// markup in the output.
export function escapeHtmlWithBreaks(value) {
  return escapeHtml(value).replace(/(?:\r\n|\r|\n)/g, '<br>');
}

export default escapeHtml;
